export default "__VITE_ASSET__B1SP9ggl__"